import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../../ui/button/index.js";

/** Primary "go back" link on route status pages. Replaces history so Back does not return to the dead URL. */
export function RouteStatusAction({ to, label }: { to: string; label: string }): React.JSX.Element {
  return (
    <Button
      asChild
      size="lg"
      className="group h-12 gap-2.5 rounded-[12px] border-brand-primary bg-brand-primary px-6 text-[15px] font-[750] text-white shadow-[0_6px_16px_rgba(23,126,103,0.18)] transition-[background-color,border-color,box-shadow,translate] not-disabled:hover:border-brand-primary-hover not-disabled:hover:bg-brand-primary-hover hover:shadow-[0_8px_22px_rgba(23,126,103,0.26)] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-brand/35 focus-visible:ring-offset-2 focus-visible:ring-offset-[#f8faf9] active:translate-y-px"
    >
      <Link to={to} replace>
        <ArrowLeft
          size={18}
          strokeWidth={2}
          aria-hidden="true"
          className="shrink-0 transition-[translate] duration-150 ease-out rtl:-scale-x-100 group-hover:-translate-x-0.5 rtl:group-hover:translate-x-0.5 motion-reduce:transition-none"
        />
        {label}
      </Link>
    </Button>
  );
}
